<template>
    <div>
        <div class="form-group">
            <legend>Kategorier</legend>
            <ul class="types--list row" v-if="categories.length > 0">
                <li v-for="category in selectableCategories">
                    <label
                        class="form-control types--list-option"
                        v-bind:class="{
                            'is-selected':
                                propSelectedIds.length > 0 && propSelectedIds.indexOf(category.id) != -1
                        }"
                    >
                        <input
                            type="checkbox"
                            name="categories[]"
                            :value="category.id"
                            v-model="propSelectedIds"
                        />
                        <span>{{ category.text }}</span>
                    </label>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    props: {
        preSelectedIds: {
            type: Array,
            default: () => []
        },

        preSelectedTitles: {
            type: Array,
            default: () => []
        }
    },

    computed: {
        selectableCategories: function () {
            return this.categories.filter((child) => child.depth > 1 || child.slug == 'populaera');
        }
    },

    mounted() {
        this.getCategories();
        this.propSelectedIds = this.preSelectedIds;
    },

    data() {
        return {
            categories: [],
            propSelectedIds: []
        };
    },

    methods: {
        getCategories: function () {
            axios.get('/recept/api/categories').then((response) => {
                this.categories = response.data;
            });
        }
    }
};
</script>
